<app-filter
  [options]="options"
  [value$]="ordering$"
  (valueChanged)="onSetSortingOptionsValue($event)"
/>
